import { FC } from "react"

interface NumberInputProps {
  label: string
  value: number | undefined
  onChange: (val: number) => void
  step?: number
  min?: number
  max?: number
  placeholder?: string
}

export const NumberInput: FC<NumberInputProps> = ({ label, value, onChange, step = 1, min, max, placeholder }) => (
  <div>
    <label className="text-xs text-gray-500 dark:text-gray-400">{label}</label>
    <input
      type="number"
      step={step}
      min={min}
      max={max}
      value={value ?? ""}
      onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
      className="w-full px-3 py-2 border rounded dark:bg-gray-800 dark:border-gray-700 dark:text-white"
      placeholder={placeholder}
    />
  </div>
)
